import React, { useEffect, createElement } from 'react';
import { TopBanner } from './components/TopBanner';
import { Hero } from './components/Hero';
import { Bullets } from './components/Bullets';
import { SocialProof } from './components/SocialProof';
import { EmotionalBenefit } from './components/EmotionalBenefit';
import { HowItWorks } from './components/HowItWorks';
import { FrictionReduction } from './components/FrictionReduction';
import { FinalCTA } from './components/FinalCTA';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  useEffect(() => {
    // Install Meta Pixel
    const w = window as any;
    if (!w.fbq) {
      const n = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    w.fbq('init', '1225428543097695');
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white text-gray-900 selection:bg-orange-100 selection:text-orange-900 pb-24 md:pb-0" data-id="element-0">
      <TopBanner data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Bullets data-id="element-4" />
        <SocialProof data-id="element-5" />
        <EmotionalBenefit data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <FrictionReduction data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>

      <StickyMobileCTA data-id="element-10" />
    </div>;
}